import React, {useMemo, useState} from 'react';
import {
    MaterialReactTable,
    type MRT_ColumnDef,
    type MRT_ColumnFiltersState,
    MRT_EditActionButtons,
    type MRT_Row,
    useMaterialReactTable,
} from 'material-react-table';
import {Box, Button, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Tooltip,} from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

import AddDipProg from "./AddDipProg";
import {useDeleteDipProg, useGetDipProgDTO} from "./Services";
import EditDipProg from "./EditDipProg";
import ExpDipProg from "./ExpDipProg";
import {DipProgDTO} from "./types";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {useTabSettings} from "../../common/Services";
import DropDipProg2 from "./DropDipProg2";


interface ListaDipProgProps {
  // propflgtemp: string;
}

const ListaDipProg: React.FC<ListaDipProgProps> = () => {
  const [validationErrors, setValidationErrors] = useState< Record<string, string | undefined>>({});
  const [globalFilter, setGlobalFilter] = useState('');
const [isDialogExporterOpen, setIsDialogExporterOpen] = useState(false);



  const columns = useMemo<MRT_ColumnDef<DipProgDTO>[]>(
  () => [
   {
      accessorKey: 'id',
      header: 'Id',
      size: 5,
      enableEditing: false,
    },
   {
      accessorKey: 'molt', // New lookup column
      header: 'Moltip.Ore',
      size: 2,
    },

   {
      accessorKey: 'ditta', // New lookup column
      header: 'Ditta',
      size: 2,
    },
   {
      accessorKey: 'coddip', // New lookup column
      header: 'CodDip',
      size: 5,
    },
   {
      accessorKey: 'nomedip', // New lookup column
      header: 'NomeDip',
      size: 10,
    },
   {
      accessorKey: 'codprog', // New lookup column
      header: 'CodProg',
      size: 5,
    },
   {
      accessorKey: 'desprog', // New lookup column
      header: 'DesProg',
      size: 30,
    },
    {
      accessorKey: 'ref', // New lookup column
      header: 'Ref',
      size: 10,
    },

      ],
 [validationErrors]
);




  const keyusername = localStorage.getItem('keyusername') || 'NN';
  const {columnVisibility,  setColumnVisibility,  columnFilters, setColumnFilters,  sorting,  setSorting, pagination,  setPagination,  saveTabSettings,} = useTabSettings('ListaDipProg', keyusername);
  const [draftColumnFilters, setDraftColumnFilters] = useState<MRT_ColumnFiltersState>(columnFilters);


  const { data: { results = [], count } = {}, isError: isLoadingDipProgDTOError, isFetching: isFetchingDipProgDTO, isLoading: isLoadingDipProgDTO } = useGetDipProgDTO(pagination, columnFilters, globalFilter, sorting);
  const { mutateAsync: deleteDipProg, isPending: isDeletingDipProg } = useDeleteDipProg();



  const [isDialogEditOpen, setIsDialogEditOpen] = useState(false);
  const [currentRowId, setCurrentRowId] = useState('0');
  const [isDialogAddOpen, setIsDialogAddOpen] = useState(false);
  const [isDialogDropOpen, setIsDialogDropOpen] = useState(false);

  const [isDialogDrop2Open, setIsDialogDrop2Open] = useState(false);


const openDeleteConfirmModal = (row: MRT_Row<DipProgDTO>) => {
    const id = row.original.id;

    if (!id) {
        console.error("Invalid ID:", row.original.id);
        return;
    }

    if (window.confirm(`ATTENZIONE !!! CANCELLAZIONE DEL ... " ${id} "`)) {
        deleteDipProg(id);
    }
};


  const openAddModal = () => {
        setIsDialogAddOpen(true);
  };

 const openDropModal = () => {
        setIsDialogDropOpen(true);
  };

 const openDrop2Modal = () => {
        setIsDialogDrop2Open(true);
  };



const openEditModal = (row: MRT_Row<DipProgDTO>) => {
  const id = row.original.id;

  if (!id) {
    console.error("ID non valido:", row.original);
    return;
  }

  setCurrentRowId(id.toString());
  setIsDialogEditOpen(true);
};

  const table = useMaterialReactTable({
    columns,
    data: results,
    initialState: { density: 'compact' },

    manualFiltering: true, //turn off built-in client-side filtering
    manualPagination: true, //turn off built-in client-side pagination
    manualSorting: true, //turn off built-in client-side sorting

    createDisplayMode: 'modal', //default ('row', and 'custom' are also available)
    editDisplayMode: 'modal', //default ('row', 'cell', 'table', and 'custom' are also available)
    enableEditing: true,
    enableColumnActions: true,
    /*
    muiPaginationProps: {
      disabled: isFetchingDipProg,
    },
    */

    getRowId: (row) => (row.id ? row.id.toString() : ''),




    muiToolbarAlertBannerProps: isLoadingDipProgDTOError ? {
          color: 'error',
          children: 'Error loading data',
        } : undefined,
    muiTableContainerProps: {
      sx: {
        minHeight: '500px',
      },
    },
     // per compattazione tabella padding first above and below second left and right
     muiTableBodyCellProps: {
          sx: {
            padding: '0.5px 4px',
            fontSize: '.9rem',
          },
        },

     muiTableHeadCellProps: {
          sx: {
            padding: '0.5px 4px',
            fontSize: '0.9rem',
          },
        },


    // muiEditRowDialogProps: {
    //    fullWidth: true,
    //    maxWidth: 'md',
    //  },
    onColumnFiltersChange: setDraftColumnFilters,
    // onColumnFiltersChange: (updater) => {
    //   const newFilters = typeof updater === 'function' ? updater(columnFilters) : updater;
    //   setColumnFilters(newFilters);
    //   saveTabSettings(columnVisibility, newFilters, sorting, pagination);
    // },
    onSortingChange: (updater) => {
      const newSorting = typeof updater === 'function' ? updater(sorting) : updater;
      setSorting(newSorting);
      saveTabSettings(columnVisibility, columnFilters, newSorting, pagination);
    },
    onPaginationChange: (updater) => {
      const newPagination = typeof updater === 'function' ? updater(pagination) : updater;
      setPagination(newPagination);
      saveTabSettings(columnVisibility, columnFilters, sorting, newPagination);
    },
    onColumnVisibilityChange: (updater) => {
      const newVisibility = typeof updater === 'function' ? updater(columnVisibility) : updater;
      setColumnVisibility(newVisibility);
      saveTabSettings(newVisibility, columnFilters, sorting, pagination);
    },


    onCreatingRowCancel: () => setValidationErrors({}),
    onEditingRowCancel: () => setValidationErrors({}),






     renderCreateRowDialogContent: ({ table, row, internalEditComponents }) => (
         <>
        <DialogTitle variant="h3">Crea Nuovo </DialogTitle>
        <DialogContent
           sx={{ width: '1000px'}}
        >
          {internalEditComponents} {/* or render custom edit components here */}

        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>

       </>
    ),


   renderEditRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>
        <DialogTitle variant="h3">Edit PrevTesta</DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}
        >
          {internalEditComponents} {/* or render custom edit components here */}
        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>
      </>
    ),

 renderRowActions: ({ row }) => (
  <Box sx={{ display: 'flex', gap: '2px' }}>
    <Tooltip title="Modifica">
      <IconButton
        size="small"
        sx={{ padding: '2px' }}
        onClick={() => openEditModal(row)}
      >
        <EditIcon sx={{ fontSize: 20 }} />
      </IconButton>
    </Tooltip>

    <Tooltip title="Rimuovi">
      <IconButton
        size="small"
        color="error"
        sx={{ padding: '2px' }}
        onClick={() => openDeleteConfirmModal(row)}
      >
        <DeleteIcon sx={{ fontSize: 20 }} />
      </IconButton>
    </Tooltip>
  </Box>
),


    renderTopToolbarCustomActions: ({ table }) => (
      <>
       <Stack
              direction="row"
              spacing={0}
              sx={{
                width: '60%',
                padding: '4px',
                alignItems: 'center',
              }}
            >

                <Box sx={{ width: '25%' }}>

       <Button sx={{ width: 160 }} variant="contained" onClick={openAddModal}>Nuovo</Button>
        {isDialogAddOpen && (<AddDipProg onClose={() => {setIsDialogAddOpen(false); }}  /> )}
                </Box>
        {/*      <Box sx={{ width: '25%' }}>*/}
        {/*<Button sx={{ width: 160 }} variant="contained" onClick={openDropModal}>ASS.RISORSE</Button>*/}
        {/*{isDialogDropOpen && (<DropDipProg onClose={() => {setIsDialogDropOpen(false); }}  /> )}*/}
        {/*        </Box>*/}
              <Box sx={{ width: '25%' }}>
        <Button sx={{ width: 160 }} variant="contained" onClick={openDrop2Modal}>ASS.RISORSE 2</Button>
        {isDialogDrop2Open && (<DropDipProg2 onClose={() => {setIsDialogDrop2Open(false); }}  /> )}
                </Box>

                <Box sx={{ width: '25%' }}>
        <Button sx={{ width: 160 }} variant="contained"   onClick={() => setIsDialogExporterOpen(true)} startIcon={<FileDownloadIcon />} > EXPORT DATI </Button>
        {isDialogExporterOpen && (
            <ExpDipProg
                      pagination={pagination}
                      columnFilters={columnFilters}
                      globalFilter={globalFilter}
                      sorting={sorting}
                      columnVisibility={columnVisibility}
                      columns={columns}
                      onClose={() => setIsDialogExporterOpen(false)}
            />
          )}
                </Box>
                <Box sx={{ width: '25%'}}>
                        <Button
                          variant="contained"
                          onClick={() => {
                            setColumnFilters(draftColumnFilters);
                            saveTabSettings(columnVisibility, draftColumnFilters, sorting, pagination);
                          }}
                          sx={{ width: 160 }}
                        >
                          Applica Filtri
                        </Button>
                </Box>
        </Stack>
      </>
      ),

    //rowCount: meta?.totalRowCount ?? 0,
    rowCount: count ?? 0,

    state: {
       isLoading: isLoadingDipProgDTO,
       // isSaving: isCreatingDipProgDTO || isUpdatingDipProgDTO || isDeletingDipProg,
       isSaving: isDeletingDipProg,
       showAlertBanner: isLoadingDipProgDTOError,
       showProgressBars: isFetchingDipProgDTO,

      columnFilters,
      globalFilter,
      pagination,
      sorting,
    },
  });

return (
     <Box sx={{ mt: "60px" }}>
        <MaterialReactTable table={table} />

          {isDialogEditOpen && (
          <EditDipProg
            idprop={currentRowId}
            onClose={() => setIsDialogEditOpen(false)}
          />
        )}

     </Box>



  );

};

export default ListaDipProg;

